import React, { useState } from "react";
import ssoImg1 from "./../../../../assets/images/psc-img.png"; // Adjust the path as necessary
import map from './../../../../assets/images/map.png';
import pilotIcon from "./../../../../assets/images/user-pilot-tie.svg"; // Adjust the path as necessary
import scaleIcon from "./../../../../assets/images/scale-balanced.svg"; // Adjust the path as necessary

import { FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube, FaUser, FaInstagram } from 'react-icons/fa';

function ShippingSafetyPortStateControlTab() {
    const cardData = [
  {
    icon: scaleIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "  The objective of  the Authority is to carry out port state control to eliminate  substandard ships from the region and threat they post to life, property and the marine environment.",
  },
  {
    icon: scaleIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: " Under SAMSA’s eight different ports we have 28 Inspectors which are also flag state surveyors in those ports, performing duties on Maritime Safety.",
  },
  
  

  
  
  

  
];



  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        SHIPPING SAFETY 
        <span className="text-orange-ef3e33 font-400"> PORT STATE CONTROL </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-12">
          <p className="font-18 font-900 mb-3">Port State Control Regions</p>

          <img src={map} className="w-100" alt="" />
        </div>
        <div className="col-lg">
          
          <p className="mb-3 text-primary-color">The Centre adheres to various national and international standards (IMO  Standards) by conducting Surveys of Ships (all South African Registered  Convention Ships and Non- Convention Ships</p>

          <p className="mb-3 text-primary-color">The surveys are conducted by SAMSA Surveyors and SAMSA Approved Surveyors.</p>

          <p className="mb-3 text-primary-color">Regional Control provides fast and reliable communications  between the States in the region, and between regions is imperative.</p>

          <p className="mb-3 text-primary-color">South Africa is signatory or member of the Indian Ocean Memorandum of Understanding(IOMoU) and the Memorandum of Understanding on Port State Control for West and Central African Region(Abuja MoU).     The IOMOU has the Indian Ocean Computerized information System (IOCIS), while others have their own and,    ABUJA MoU has the Abuja MoU Information System (AMIS)</p>
          
          

          


        </div>
        <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div>

        <div className="col-12">
          <p className="font-18 font-900 mb-3">Port State Inspection Fees and Penalties<br className="d-none d-md-block"/> South African Maritime Safety Authority (SAMSA)</p>

      
<div className="row g-4">
           {cardData.map((card, index) => (
              <div className="col-md-6 col-sm-6" key={index}>
                <div className="gray-card-wrap">
                  <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                    <div className="icon">
                      <img src={card.icon} alt="" />
                    </div>
                    <div className="text-center text-primary-color">
                      {card.cardDescription}
                    </div>

                    <div className="card-share">
                      {/* <button type="button" className="btn-share border-0" >
                        <i className="bi bi-share"></i>
                      </button> */}
                      <ul>
                        <li>
                          <a href="#">
                            <FaFacebookF />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaTwitter />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaLinkedinIn />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaInstagram />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaYoutube />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="col-md-8">

          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="false"
                  aria-controls="blackTabOne"
                >
                    Table 1 Fees and Penalties
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-12">
                      <p className="mb-3">
                        <b className="d-block">NIR STATISTICS</b>
                        N/A
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Inspecting Authority</b>
                        N/A
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Priority I (*)</b>
                        N/A
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Priority II  </b>
                        Target (70% of N) <span className="text-orange-ef3e33">92</span> <br/>
                        Actual <span className="text-orange-ef3e33">95 (73%)</span> <br/>
                        %age target achieved <span className="text-orange-ef3e33">103.26</span>
                      </p>

                      <p className="">
                        <b className="d-block">Priority I (*)</b>
                        Actual <span className="text-orange-ef3e33">26 (20%)</span>
                      </p>

                    <div className="row g-2">
                      <div className="col-auto">Note :</div>
                      <div className="col-auto">NIR is implemented from 01.01.2019.<br/>
                         (*) Target for Priority I PSC inspections is 70% (IOCM22) w.r.t</div>
                      <div className="col-12">
                          NIR implementation.
                      </div>
                    </div>
                      
                      
                    </div>

                 
                  </div>
                  
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header ">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabTwo"
                  aria-expanded="true"
                  aria-controls="blackTabOne"
                >Table 2 – 10-year summary of inspection, detentions and deficiency rate</button>
              </h2>
              <div
                id="blackTabTwo"
                className="accordion-collapse collapse show"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-12">
                      <p className="mb-3">
                        <b className="d-block">NIR STATISTICS</b>
                        N/A
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Inspecting Authority</b>
                        N/A
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Priority I (*)</b>
                        N/A
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Priority II  </b>
                        Target (70% of N) <span className="text-orange-ef3e33">92</span> <br/>
                        Actual <span className="text-orange-ef3e33">95 (73%)</span> <br/>
                        %age target achieved <span className="text-orange-ef3e33">103.26</span>
                      </p>

                      <p className="">
                        <b className="d-block">Priority I (*)</b>
                        Actual <span className="text-orange-ef3e33">26 (20%)</span>
                      </p>

                    <div className="row g-2">
                      <div className="col-auto">Note :</div>
                      <div className="col-auto">NIR is implemented from 01.01.2019.<br/>
                         (*) Target for Priority I PSC inspections is 70% (IOCM22) w.r.t</div>
                      <div className="col-12">
                          NIR implementation.
                      </div>
                    </div>
                      
                      
                    </div>

                 
                  </div>
                  
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header ">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabThree"
                  aria-expanded="false"
                  aria-controls="blackTabThree"
                >Summary of inspections for 2021</button>
              </h2>
              <div
                id="blackTabThree"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-12">
                      <p className="mb-3">
                        <b className="d-block">NIR STATISTICS</b>
                        N/A
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Inspecting Authority</b>
                        N/A
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Priority I (*)</b>
                        N/A
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Priority II  </b>
                        Target (70% of N) <span className="text-orange-ef3e33">92</span> <br/>
                        Actual <span className="text-orange-ef3e33">95 (73%)</span> <br/>
                        %age target achieved <span className="text-orange-ef3e33">103.26</span>
                      </p>

                      <p className="">
                        <b className="d-block">Priority I (*)</b>
                        Actual <span className="text-orange-ef3e33">26 (20%)</span>
                      </p>

                    <div className="row g-2">
                      <div className="col-auto">Note :</div>
                      <div className="col-auto">NIR is implemented from 01.01.2019.<br/>
                         (*) Target for Priority I PSC inspections is 70% (IOCM22) w.r.t</div>
                      <div className="col-12">
                          NIR implementation.
                      </div>
                    </div>
                      
                      
                    </div>

                 
                  </div>
                  
                </div>
              </div>
            </div>
          
           
          </div>
        </div>
        

      
      </div>
    </>
  );
}

export default ShippingSafetyPortStateControlTab;